import Environment from '@config/index';
import { axios, getAxiosConfig } from '@config/axios';
import logger from '@helpers/utils/logger/client';
import { KycTemplateInquiry } from '@interfaces/models/kyc';

export default class MyAccountService {
  private static baseUrl = Environment.apiBaseUrl;

  static async accountClose() {
    const axiosConfig = getAxiosConfig();
    const url = `${this.baseUrl}/account/close`;
    try {
      const response = await axios.post(url, {}, axiosConfig);
      return response?.status === 204;
    } catch (error) {
      logger.error('my-account-service::account-close::generic', error.response);
      throw error;
    }
  }

  static async getKycPersonaInquiry(kycRequestId: string) {
    const axiosConfig = getAxiosConfig();

    const url = `${this.baseUrl}/kyc/persona/inquiry`;

    const requestConfig = {
      ...axiosConfig,
      // eslint-disable-next-line
      params: {
        ...axiosConfig.params,
        kycRequestId,
      },
    };

    try {
      const response = await axios.get<{ data: KycTemplateInquiry }>(url, requestConfig);
      return response.data.data;
    } catch (error) {
      logger.error('my-account-service::kyc-persona::generic', error.response);
      throw error;
    }
  }
}
